import React, { useState } from "react";
import { FaEdit, FaHeart, FaUsers, FaShieldAlt } from "react-icons/fa";
import "./Aboutus.css";

const AboutUs = () => {
  const [editMode, setEditMode] = useState("");
  const [content, setContent] = useState({
    heroTitle: "Find Your Perfect Match withWarangal",
    heroSubtitle: "Connecting hearts with trust, compatibility, and commitment.",
    aboutText: "Welcome toWarangal, the premier matrimony platform designed to help individuals find their perfect life partners. We believe that every love story begins with a meaningful connection, and our mission is to make that journey seamless, secure, and memorable.",
    visionText: " Our vision is to redefine the matchmaking experience by blending technology with tradition. We aim to create a trustworthy and reliable platform where individuals can find partners who align with their values, aspirations, and cultural preferences.",
    imageSrc: "/Images/pair.jpg",
    whyChooseText: "Building trust, security, and compatibility to connect hearts with confidence.",
    servicesText: "Explore our premium matchmaking services."
  });

  // Modal Control
  const [isEditingImage, setIsEditingImage] = useState(false);
  const [tempImage, setTempImage] = useState(content.imageSrc);

  // Handle inline text updates
  const handleTextChange = (field, value) => {
    setContent({ ...content, [field]: value });
  };
  

  return (
    <div className="about-containerA99">
      {/* Hero Section */}
      <section className="hero-sectionA99">
        <div className="overlayA99">
          {editMode === "heroTitle" ? (
            <input
              value={content.heroTitle}
              onChange={(e) => handleTextChange("heroTitle", e.target.value)}
              onBlur={() => setEditMode("")}
              autoFocus
            />
          ) : (
            <h1 onClick={() => setEditMode("heroTitle")}>
              {content.heroTitle} <FaEdit className="edit-icon" />
            </h1>
          )}

          {editMode === "heroSubtitle" ? (
            <input
          
              value={content.heroSubtitle}
              onChange={(e) => handleTextChange("heroSubtitle", e.target.value)}
              onBlur={() => setEditMode("")}
              autoFocus
            />
          ) : (
            <p  className="herosubtitle" onClick={() => setEditMode("heroSubtitle")}>
              {content.heroSubtitle} <FaEdit className="edit-icon" />
            </p>
          )}
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-contentA99">
        <div className="about-textA99">
          <h2>Who We Are</h2>
          {editMode === "aboutText" ? (
            <textarea
              value={content.aboutText}
              onChange={(e) => handleTextChange("aboutText", e.target.value)}
              onBlur={() => setEditMode("")}
              autoFocus
            />
          ) : (
            <p onClick={() => setEditMode("aboutText")}>
              {content.aboutText} <FaEdit className="edit-icon" />
            </p>
          )}
        </div>

        <div className="our-visionA99">
          <h2>Our Vision</h2>
          {editMode === "visionText" ? (
            <textarea
              value={content.visionText}
              onChange={(e) => handleTextChange("visionText", e.target.value)}
              onBlur={() => setEditMode("")}
              autoFocus
            />
          ) : (
            <p onClick={() => setEditMode("visionText")}>
              {content.visionText} <FaEdit className="edit-icon" />
            </p>
          )}
        </div>

        <div className="about-imageA99">
          <img src={content.imageSrc} alt="Lovely Pair" />
          <FaEdit className="edit-icon image-edit" onClick={() => setIsEditingImage(true)} />
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-chooseA99">
        <h2>Why Choose Us?</h2>
        {editMode === "whyChooseText" ? (
          <textarea
            value={content.whyChooseText}
            onChange={(e) => handleTextChange("whyChooseText", e.target.value)}
            onBlur={() => setEditMode("")}
            autoFocus
          />
        ) : (
          <p onClick={() => setEditMode("whyChooseText")}>
            {content.whyChooseText} <FaEdit className="edit-icon" />
          </p>
        )}

        <div className="featuresA99">
          <div className="feature-boxA99">
            <FaHeart className="iconA99" />
            <h3>Smart Matchmaking</h3>
            <p>Our advanced algorithm connects you with compatible profiles.</p>
          </div>
          <div className="feature-boxA99">
            <FaShieldAlt className="iconA99" />
            <h3>Privacy & Security</h3>
            <p>We ensure robust data protection and profile verification.</p>
          </div>
          <div className="feature-boxA99">
            <FaUsers className="iconA99" />
            <h3>Astrology Insights</h3>
            <p>Get expert astrological consultations for compatibility.</p>
          </div>
        </div>
      </section>

      {/* Our Services */}
      <section className="our-servicesA99">
        <h2>Our Services</h2>
        {editMode === "servicesText" ? (
          <textarea
            value={content.servicesText}
            onChange={(e) => handleTextChange("servicesText", e.target.value)}
            onBlur={() => setEditMode("")}
            autoFocus
          />
        ) : (
          <p onClick={() => setEditMode("servicesText")}>
            {content.servicesText} <FaEdit className="edit-icon" />
          </p>
        )}
        <ul>
          <li><strong>Personalized Profile & Partner Search:</strong> Create a detailed profile.</li>
          <li><strong>Subscription Plans:</strong> Access premium features.</li>
          <li><strong>Verified Profiles:</strong> We ensure trusted community connections.</li>
          <li><strong>Legal Assistance:</strong> Get expert legal guidance.</li>
          <li><strong>Astrology Guidance:</strong> Consult relationship advisors.</li>
        </ul>
      </section>

      {/* Image Edit Modal */}
      {isEditingImage && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Edit Image URL</h3>
            <input
              type="text"
              className="modal-input"
              value={tempImage}
              onChange={(e) => setTempImage(e.target.value)}
            />
            <div className="modal-buttons">
              <button className="modal-btn update-btn" onClick={() => { setContent({ ...content, imageSrc: tempImage }); setIsEditingImage(false); }}>Update</button>
              <button className="modal-btn close-btn" onClick={() => setIsEditingImage(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUs;
